import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-285d0b87")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_2 = { class: "p-d-flex p-jc-between" }
const _hoisted_3 = { class: "p-text-left" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Good'))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('Bad'))
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_badge = _resolveDirective("badge")!

  return (!_ctx.rows)
    ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
    : (_openBlock(), _createBlock(_component_DataTable, {
        key: 1,
        class: "detailTable ch-datatable p-datatable-ssm",
        responsiveLayout: "scroll",
        value: !_ctx.feedbacks ? [] : _ctx.rows,
        showGridlines: "",
        scrollable: true,
        scrollHeight: "37.5rem"
      }, {
        empty: _withCtx(() => [
          _hoisted_1
        ]),
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, [
                (_ctx.staffMember)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
                name: _ctx.EducationRouteNames.PERSON_PROFILE_GENERAL,
                params: {
                  personId: _ctx.staffMember.user?.personId
                }
              }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.staffMember.profile?.name) + " " + _toDisplayString(_ctx.staffMember.profile?.lastName), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_ctx.evaluateSummary === _ctx.EvaluateSummary.content)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.syllabusVersion
                  ? `Programa versión ${_ctx.syllabusVersion}`
                  : 'Contenido'), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, " Valoraciones del equipo a la clase ")),
                _createElementVNode("span", {
                  class: _normalizeClass(["p-ml-2", 
                _ctx.averageRate >= 4.7 ? 'text-green-brain' : 'text-red-brain'
              ])
                }, _toDisplayString(_ctx.averageRate !== 0 ? _ctx.averageRate : '-'), 3)
              ])
            ]),
            (_ctx.summaryRole !== _ctx.EvaluateSummary.staff)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _withDirectives(_createVNode(_component_Tag, {
                    class: "p-tag-light-green-brain p-ml-1 p-mr-1",
                    style: {"min-width":"4.375rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.tagsSummary ? _ctx.tagsSummary.goodTags : '-') + " / " + _toDisplayString(_ctx.studentAttendances || '-'), 1)
                    ]),
                    _: 1
                  }, 512), [
                    [
                      _directive_tooltip,
                      'Tags positivas sobre estudiantes asistentes',
                      void 0,
                      {
                        top: true,
                        blur: true
                      }
                    ]
                  ]),
                  _withDirectives(_createVNode(_component_Tag, {
                    class: "p-tag-red-brain p-ml-1 p-mr-1",
                    style: {"min-width":"4.375rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.tagsSummary ? _ctx.tagsSummary.AllNegative : '-') + "/" + _toDisplayString(_ctx.studentAttendances || '-'), 1)
                    ]),
                    _: 1
                  }, 512), [
                    [
                      _directive_tooltip,
                      'Tags negativas sobre estudiantes asistentes',
                      void 0,
                      {
                        top: true,
                        blur: true
                      }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: 
        _ctx.evaluateSummary === _ctx.EvaluateSummary.staff ? 'Tutor' : 'Estudiante'
      ,
            key: _ctx.ColumnFields.Person,
            style: {"vertical-align":"top","flex":"0 0 10%"},
            bodyClass: "text-col-personName",
            field: "personName",
            headerClass: "text-size-12"
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            header: "Valoración",
            key: _ctx.ColumnFields.Rating,
            style: {"vertical-align":"top","flex":"0 0 20%"},
            headerClass: "text-size-12"
          }, {
            body: _withCtx(({ data }) => [
              (data.rating)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass([
            'p-text-center w100',
            data.rating >= 4.7 ? 'text-green-brain' : 'text-red-brain'
          ])
                  }, _toDisplayString(data.rating), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.evaluateSummary !== _ctx.EvaluateSummary.staff)
            ? (_openBlock(), _createBlock(_component_Column, {
                header: "Tags",
                key: _ctx.ColumnFields.Tags,
                style: {"vertical-align":"top","text-align":"center","'flex":"0 0 20%"},
                bodyClass: "p-d-flex p-jc-center p-col-12",
                bodyStyle: "width:100%;",
                headerClass: "text-size-12"
              }, {
                body: _withCtx(({ data }) => [
                  (data.tags[0]?.character === _ctx.FeedbackCharacter.Positive)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        class: "p-m-2 min-width-70 p-tag-light-green-brain"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1536)), [
                        [
                          _directive_tooltip,
                          `${_ctx.allTagText(data.tags)}`,
                          void 0,
                          {
                            top: true,
                            blur: true
                          }
                        ],
                        [
                          _directive_badge,
                          data.tags.length,
                          void 0,
                          { success: true }
                        ]
                      ])
                    : (data.tags[0]?.character !== _ctx.FeedbackCharacter.Positive)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Tag, {
                          key: 1,
                          class: "p-m-2 min-width-70 p-tag-red-brain"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1536)), [
                          [
                            _directive_tooltip,
                            `${_ctx.allTagText(data.tags)}`,
                            void 0,
                            {
                              top: true,
                              blur: true
                            }
                          ],
                          [
                            _directive_badge,
                            data.tags?.length,
                            void 0,
                            { danger: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, {
            header: "Valoración",
            key: _ctx.ColumnFields.Rating,
            style: _normalizeStyle([
        'vertical-align: top;',
        _ctx.evaluateSummary !== _ctx.EvaluateSummary.staff
          ? 'flex: 0 0 50%;'
          : 'flex: 0 0 70%;'
      ]),
            bodyClass: "text-col-comments",
            headerClass: "text-size-12"
          }, {
            body: _withCtx(({ data }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.comments, (comment) => {
                return (_openBlock(), _createElementBlock("p", { key: comment }, _toDisplayString(comment), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value"]))
}